import { Component, OnInit } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { UntypedFormGroup } from '@angular/forms';
import { FormattingService } from '../../../shared/services/formatting.service';

@Component({
  selector: 'combined-date-demo',
  template: `
    <div>
      <h2>Combined Date Component Demo!</h2>
      <formly [fields]="fields" [model]="model" [form]="form"></formly>
      <h3>Model</h3>
      {{ model | json }}
    </div>
  `
})
export class CombinedDateDemoComponent implements OnInit {
  public model:any = {
    value1: this.formattingService.parseDate('01/01/2014'),
    value2: 'sysdate-1'
  };

  public fields:IExtraFieldConfigurationObject[];
  public form:UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private formlyService:GaFormlyService,
    private formattingService:FormattingService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.fields = [
      this.formlyService.aValue('value1', 'Text 1').build(),
      this.formlyService.aCombinedDate('value1', 'CombinedDate 1')
        .onChange((date) => console.log('onChange', date))
        .build(),

      this.formlyService.aValue('value2', 'Text 2').build(),
      this.formlyService.aCombinedDate('value2', 'CombinedDate 2').build()
    ];
  }
}